import { Tag as AntTag, TagProps } from "antd";
import styled from "styled-components";

export const Tag: typeof AntTag = styled(AntTag)<TagProps>``;
